export abstract class ApiError extends Error {
  abstract readonly code: string;
  abstract readonly status: number;
  readonly details?: unknown;

  constructor(message: string, details?: unknown) {
    super(message);
    this.name = this.constructor.name;
    this.details = details;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- V8-specific API absent in non-Node environments; typed as always-present in @types/node but runtime presence is not guaranteed
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

export class UnauthenticatedError extends ApiError {
  readonly code = "UNAUTHENTICATED";
  readonly status = 401;
}

export class ForbiddenError extends ApiError {
  readonly code = "FORBIDDEN";
  readonly status = 403;
}

export class BadRequestError extends ApiError {
  readonly code = "BAD_REQUEST";
  readonly status = 400;
}

export class NotFoundError extends ApiError {
  readonly code = "NOT_FOUND";
  readonly status = 404;
}

export class ConflictError extends ApiError {
  readonly code = "CONFLICT";
  readonly status = 409;
}

export class RateLimitedError extends ApiError {
  readonly code = "RATE_LIMITED";
  readonly status = 429;
}

export class UpstreamError extends ApiError {
  readonly code = "UPSTREAM_FAILED";
  readonly status = 502;
}

export class InternalError extends ApiError {
  readonly code = "INTERNAL";
  readonly status = 500;
}
